// extracted by mini-css-extract-plugin
export default {"container":"blog_container__A-XOV","child1":"blog_child1__vDB7-","child2":"blog_child2__8ALvu","line":"blog_line__6er96"};